import { useCallback, useState } from 'react';
import { useQueryThemes } from '../../../hooks/API/useQueryThemes';
import { createMockEntitiesArray } from '../../../utils/collectionAdapters';
import { COUNT_NAVIGATION_LINKS, getCollection } from '../utils';

export const useThemes = (queryOptions = {}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = useCallback(
    () => setIsExpanded((isExpanded) => !isExpanded),
    []
  );
  const query = useQueryThemes(null, queryOptions);

  const data = getCollection(query.data?.items, isExpanded);
  const collection = query.isLoading
    ? createMockEntitiesArray(COUNT_NAVIGATION_LINKS)
    : data;

  return { collection, query, isExpanded, toggleExpand };
};
